module.exports = require("@vscode-alt/monaco-editor/esm/vs/platform/contextkey/common/contextkey");